
// Page Paths
export const HOME_LOCATION_PATH = "/";

// Step IDs
export const OVERVIEW = "overview";
export const DEALERSHIP_INFORMATION = "dealership-information";
export const CONTRACTS = "contracts";
export const AAC_REGISTER = "aac-register";

// Step to State Number Mapping
export const STEP_STATE: Record<string, number> = {
    [OVERVIEW]: 0,
    [DEALERSHIP_INFORMATION]: 1,
    [CONTRACTS]: 2,
    [AAC_REGISTER]: 3
};

export const getStepById = (state: number): string => {
    return Object.keys(STEP_STATE).find(key => STEP_STATE[key] === state) || OVERVIEW;
};

